// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"0d00db17","201":"52d154af","485":"1ad37ca1","500":"6a9be3d6","603":"46bd85dc","674":"c4ba546b","936":"4b62e8b4"}[chunkId] + ".chunk.js";
};